 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"styles","7":"vendors~Header~about~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~h~02613bd6","12":"vendors~Header~about~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desk~26e1b5f5","16":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","17":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","19":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","22":"vendors~Cigarette~Header~about~client~header_app~modern_desktop_home~modern_mobile_home~order~testim~0329968d","24":"vendors~AuthNew~Cigarette~ClientFormContainer~sbp~testimonials~tinkoff_iframe","25":"Header~alfa_pay~pay_card~sbp~t_pay","27":"vendors~AuthNew~Cigarette~ClientFormContainer~tinkoff_iframe","28":"vendors~Header~about~faq~header_app","30":"vendors~Header~about~header_app","32":"AuthNew~ClientFormContainer","33":"FiltersPanel","34":"Map~YandexMapsSearch","35":"vendors~AuthNew~ClientFormContainer","36":"vendors~Cigarette~tinkoff_iframe","37":"AboutRoomPopup","38":"AndroidIcon","39":"AuthNew","40":"Cigarette","41":"ClientFormContainer","42":"EmptyFiltration","43":"EmptySearch","44":"ExpensiveHotelsPopup","45":"FiltersPanelMobile","46":"FlightFail","47":"FlightsItem","48":"Header","49":"HeaderAuth","50":"IosIcon","51":"Map","52":"MountainsContainer","53":"NoTopHotel","54":"NpsForm","55":"OperatorsStatuses","56":"PriceChart","57":"SeamlessTBankAuth","58":"SearcherEmptyHotel","59":"SimilarPackagesContainer","60":"Subscribe","61":"ToAppgallery","62":"ToRustore","63":"YandexHotelMap","64":"YandexMapCheckout","65":"YandexMapsSearch","89":"sigmaInit","95":"vendors~AboutRoomPopup","96":"vendors~EmptySearch","97":"vendors~HotelNotice","98":"vendors~Subscribe","104":"vendors~sigmaInit"}[chunkId]||chunkId) + ".__" + {"2":"c200fe032998ab2a7516","7":"6316030a64b0d947e7df","12":"691ff46d3fa64b3deb95","16":"ffad4cb69db7f594870e","17":"e43235cdffdfc1c48dbe","19":"2fef6b5068966e0ac4bf","21":"6a84ef8fb2c164fc17ab","22":"1cc46429ba4da3e4b35f","24":"0a26083dde31d1492105","25":"7056c7631338a21b6be6","27":"986997b5629d4b4aa406","28":"1a499da65e69d862e884","30":"335fd7f9c0b1e73d3cf3","32":"cba6589987f0e1c95cd9","33":"396d360de786367f1aed","34":"5d07086cbb4eb5f46653","35":"9f18c25f6e1983ab1a64","36":"19d6133e486cbb71628f","37":"3e8ea1e7c4b7328d860f","38":"0d264af15a74512f5a24","39":"f517282f14a63171e305","40":"14e316cadc570e4d3cd7","41":"1ca277c937ebeb0bd630","42":"6eaaaf8fe0bff04721ee","43":"62f22b2b293fada4875e","44":"5effbc3cd6af88a69195","45":"e48087de003293d28736","46":"b0e28c2030187115e8b7","47":"1ce7594487cd9eb26946","48":"d7fc1e3671969e3fa63e","49":"cc1b9766b2c05e687fcb","50":"64b4736367e00a91f98d","51":"0ebc98272f162c6648af","52":"9d0ac756e5929b24125f","53":"6e52198b972562459176","54":"41111bb6d2dfc3c845e9","55":"e7c81802fa73bf20e2eb","56":"349629adbc32efb254bf","57":"e0f73a336b30042e2858","58":"c8b453bd926a81c1ae67","59":"6b8e15383c68c5be91a9","60":"9323529fd3c9cba02b70","61":"5a46b079578a4f73d618","62":"e76d9baaaec433f6edfb","63":"c86c0c71808dfa53ce11","64":"379c9a1af4df16502331","65":"b3c1acb77d82317f5e50","89":"716e67042ffea87d320e","95":"1423f399d316e4e16c16","96":"ba5961b5fa7b1b62f848","97":"ce726944e4ef187bba79","98":"383dbce09e8f61a42c36","104":"934e709dd45826e5041d"}[chunkId] + ".prod.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"32":1,"33":1,"34":1,"39":1,"43":1,"44":1,"46":1,"48":1,"49":1,"51":1,"53":1,"55":1,"56":1,"58":1,"63":1,"64":1,"65":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"styles","7":"vendors~Header~about~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~h~02613bd6","12":"vendors~Header~about~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desk~26e1b5f5","16":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","17":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","19":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","22":"vendors~Cigarette~Header~about~client~header_app~modern_desktop_home~modern_mobile_home~order~testim~0329968d","24":"vendors~AuthNew~Cigarette~ClientFormContainer~sbp~testimonials~tinkoff_iframe","25":"Header~alfa_pay~pay_card~sbp~t_pay","27":"vendors~AuthNew~Cigarette~ClientFormContainer~tinkoff_iframe","28":"vendors~Header~about~faq~header_app","30":"vendors~Header~about~header_app","32":"AuthNew~ClientFormContainer","33":"FiltersPanel","34":"Map~YandexMapsSearch","35":"vendors~AuthNew~ClientFormContainer","36":"vendors~Cigarette~tinkoff_iframe","37":"AboutRoomPopup","38":"AndroidIcon","39":"AuthNew","40":"Cigarette","41":"ClientFormContainer","42":"EmptyFiltration","43":"EmptySearch","44":"ExpensiveHotelsPopup","45":"FiltersPanelMobile","46":"FlightFail","47":"FlightsItem","48":"Header","49":"HeaderAuth","50":"IosIcon","51":"Map","52":"MountainsContainer","53":"NoTopHotel","54":"NpsForm","55":"OperatorsStatuses","56":"PriceChart","57":"SeamlessTBankAuth","58":"SearcherEmptyHotel","59":"SimilarPackagesContainer","60":"Subscribe","61":"ToAppgallery","62":"ToRustore","63":"YandexHotelMap","64":"YandexMapCheckout","65":"YandexMapsSearch","89":"sigmaInit","95":"vendors~AboutRoomPopup","96":"vendors~EmptySearch","97":"vendors~HotelNotice","98":"vendors~Subscribe","104":"vendors~sigmaInit"}[chunkId]||chunkId) + "." + {"2":"0ffaa8b118cefc3ac228","7":"d41d8cd98f00b204e980","12":"d41d8cd98f00b204e980","16":"d41d8cd98f00b204e980","17":"d41d8cd98f00b204e980","19":"d41d8cd98f00b204e980","21":"d41d8cd98f00b204e980","22":"d41d8cd98f00b204e980","24":"d41d8cd98f00b204e980","25":"d41d8cd98f00b204e980","27":"d41d8cd98f00b204e980","28":"d41d8cd98f00b204e980","30":"d41d8cd98f00b204e980","32":"b61c63c451d3dfcb51e1","33":"bf25ac7aeb6dccbefb83","34":"44173ef29090408cf488","35":"d41d8cd98f00b204e980","36":"d41d8cd98f00b204e980","37":"d41d8cd98f00b204e980","38":"d41d8cd98f00b204e980","39":"c06fe60c4aedeea3460c","40":"d41d8cd98f00b204e980","41":"d41d8cd98f00b204e980","42":"d41d8cd98f00b204e980","43":"7bc690fbfb444b4fb1b5","44":"44a3f21ea8acc536d3ad","45":"d41d8cd98f00b204e980","46":"3d5c7660f989b289df97","47":"d41d8cd98f00b204e980","48":"e7c7cfa52039ad4cf3f0","49":"e2dc08d21432f13fd3cc","50":"d41d8cd98f00b204e980","51":"23b2d199ef07ed3b3d27","52":"d41d8cd98f00b204e980","53":"563237d543522fbcc346","54":"d41d8cd98f00b204e980","55":"a65265f17a8153dfeb55","56":"dcd01e976637fa2df2e8","57":"d41d8cd98f00b204e980","58":"75658e3d18bc8e0d0ddd","59":"d41d8cd98f00b204e980","60":"d41d8cd98f00b204e980","61":"d41d8cd98f00b204e980","62":"d41d8cd98f00b204e980","63":"05caa9d97f0d66d5cb8f","64":"05b56ebd11809d58c1e8","65":"00473b166a1965df28ba","89":"d41d8cd98f00b204e980","95":"d41d8cd98f00b204e980","96":"d41d8cd98f00b204e980","97":"d41d8cd98f00b204e980","98":"d41d8cd98f00b204e980","104":"d41d8cd98f00b204e980"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 3 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 3 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          setTimeout(function() {
 				            var cacheBust = 'cache-bust=true' + retryAttemptString;
 				            var retryScript = loadScript(
 				              jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				              retries - 1
 				            );
 				            document.head.appendChild(retryScript);
 				          }, 0);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 3);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.cdn.level.travel/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpLtModules"] = window["wpJsonpLtModules"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
